export function isLockedByOtherUser(lockedBy?: string | null, currentUsername?: string | null): boolean {
    return !!lockedBy && lockedBy !== currentUsername;
}
